import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ViewProviderDetailsGender from "./ViewProviderDetailsGender";
import EducationDetails from "./EducationDetails";
import { MyContext } from '../../globalContext';
import { formatDateEST } from "../../utils/TimeFormat";
import { isDateWithinDaysFromToday } from "../../utils/DateUtils";

const ProviderDetailsLeft = ({
  personalDetails,
  educationList,
  languageList,
  specialityList,
  hospitalAffiliationList,
  npi1,
  officeStateAbbreviations
}) => {
  const { gender = "" } = personalDetails;
  const { selectedForDetails } = React.useContext(MyContext);
  const { activeUntil, futureTermedStates } = selectedForDetails || {};
  const activeUntilDayLimit = (officeStateAbbreviations || []).reduce((maxDayLimit, stateAbbreviation) => {
    const stateDayLimit = Number(futureTermedStates?.[stateAbbreviation]);
    if (!Number.isFinite(stateDayLimit)) {
      return maxDayLimit;
    }
    return maxDayLimit === null
      ? stateDayLimit
      : Math.max(maxDayLimit, stateDayLimit);
  }, null);
  const { t } = useTranslation();
  const formattedActiveUntil = formatDateEST(activeUntil);
  const shouldShowActiveUntil =
    formattedActiveUntil !== "" &&
    activeUntilDayLimit !== null &&
    isDateWithinDaysFromToday(activeUntil, activeUntilDayLimit);

  const getBoardCertificate = () => {
    let isBoardCertificationDisplayed = false;
    return specialityList?.specialty?.map((speci, indexspec) =>
      speci?.boardCertList?.boardCertification?.map((cert) => {
        if (cert?.boardCertStatus == "Y") {
          const data = (
            <>
              {!isBoardCertificationDisplayed && (
                <div style={{ marginTop: "2rem" }}>
                  <div className="details-subheader">
                    {t(`boardCertification`)}:
                  </div>
                </div>
              )}
              <label key={indexspec}>
                {speci?.specialityName}
                {indexspec < specialityList?.specialty?.length - 1 ? (
                  <br />
                ) : (
                  ""
                )}
              </label>
            </>
          );
          isBoardCertificationDisplayed = true;
          return data;
        }
      })
    );
  };
  return (
    <div className="details-left-content">
      <div
        style={{
          fontSize: "20px",
          lineHeight: "1.5",
          fontWeight: "bold",
        }}
      >
        {t(`providerDetails`)}
      </div>

      {gender !== "" && (
        <div style={{ marginTop: "2rem" }}>
          <ViewProviderDetailsGender gender={gender} />
        </div>
      )}

      <div style={{ marginTop: "2rem" }}>
        <EducationDetails educationList={educationList} />
      </div>

      <div>
        {languageList?.language?.length > 0 && (
          <div className="details-subheader" style={{ marginTop: "2rem" }}>
            {t(`languageSpoken`)}:
          </div>
        )}

        {languageList?.language?.length > 0 &&
          languageList?.language?.map((pralang, indexPraLang) => (
            <span key={indexPraLang}>
              {pralang?.languageName !== null && (
                <span style={{ color: "#000" }}>
                  {pralang?.languageName}
                  {indexPraLang < languageList?.language?.length - 1 ? (
                    <br />
                  ) : (
                    ""
                  )}
                </span>
              )}
            </span>
          ))}
      </div>

      {getBoardCertificate()}

      {hospitalAffiliationList?.hospitalAffiliation?.length > 0 && (
        <div style={{ marginTop: "2rem" }}>
          <span className="details-subheader">{t(`hospitalAffiliation`)}:</span>{" "}
          <br />
          {hospitalAffiliationList?.hospitalAffiliation.length > 0 &&
            hospitalAffiliationList?.hospitalAffiliation?.map((hosp, index) => (
              <div key={index}>{hosp?.facility?.facilityName}</div>
            ))}
        </div>
      )}

      {npi1 && (
        <div style={{ marginTop: "2rem" }}>
          <span className="details-subheader">{t(`npi`)}</span>
          <br />
          {npi1}{" "}
        </div>
      )}

      {
        shouldShowActiveUntil && (
          <div style={{ marginTop: "2rem" }}>
            <span className="details-subheader">{t(`activeUntil`)}</span>
            <br />
            {formattedActiveUntil}{" "}
          </div>
        )
      }
    </div>
  );
};

ProviderDetailsLeft.propTypes = {
  personalDetails: PropTypes.object,
  educationList: PropTypes.object,
  languageList: PropTypes.object,
  specialityList: PropTypes.object,
  hospitalAffiliationList: PropTypes.object,
  npi1: PropTypes.number,
  officeStateAbbreviations: PropTypes.arrayOf(PropTypes.string)
};

export default ProviderDetailsLeft;
